import store from '../store/store';
import { mutatorAction } from 'satcheljs';
import { PremiumUserResponse } from '../contracts/premiumUserResponse';

export default mutatorAction('setSecondarySubscribers', function setSecondarySubscribers(
    response: PremiumUserResponse[]
) {
    store.secondarySubscribersInfo = response;
});
